import { render, staticRenderFns } from "./Lunch.vue?vue&type=template&id=562c3c9b&scoped=true&"
import script from "./Lunch.vue?vue&type=script&lang=js&"
export * from "./Lunch.vue?vue&type=script&lang=js&"
import style0 from "./Lunch.vue?vue&type=style&index=0&id=562c3c9b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c3c9b",
  null
  
)

export default component.exports